/**
 * @description
 * Lowercases a text and uppercases its first letter
 * @param {String} text Text to be parsed
 */
const titleFormat = (text: string): string =>
  `${text[0].toUpperCase()}${text.substr(1).toLowerCase()}`;

export default titleFormat;
